export enum HandlingPaletsTaskType {
  'move-up' = 'move-up',
  'move-down' = 'move-down',
  'leave-down' = '-',
}
